import { render, staticRenderFns } from "./approve-modal.vue?vue&type=template&id=6143f143&scoped=true&"
import script from "./approve-modal.vue?vue&type=script&lang=ts&"
export * from "./approve-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6143f143",
  null
  
)

export default component.exports